import { store, categoryStore } from '@/store';
import { routeMixin } from './route';
import { getCategory } from '@/services/top5-v2-1/get-category';

export const sidebarMixin = {
    data() {
        return {
            sidebarRankingList: [],
            categoryState: categoryStore.state,
            loaded: false,
            psh: [],
        };
    },
    mixins: [routeMixin],
    watch: {
        psh: function () {
            if (this.loaded) {
                store.setPsh(this.psh);
            }
        },
    },
    methods: {
        partnerScore(partner) {
            let score = partner?.score;
            if (!score) {
                return '0.0';
            }
            if (score.toString().length < 2) {
                score = score + '.0';
            }
            return score.toString();
        },
        async getSidebarRanking(category = null) {
            if (!category) {
                category = this.getCategorySlug();
            }

            const data = await getCategory({
                category,
                hasAbRank: Boolean(this.$route.query.arnk),
                fixedPosition: this.$globalState.fixedPosition,
                boostRankingVersion: this.$route.query.brnkv,
                boostRanking: this.$route.query.brnk,
                start: '1',
                length: '5',
            });

            this.psh = data['partnerSet'];
            this.sidebarRankingList = data['partners'];
            this.loaded = true;
            store.setPageViewId(data['pageViewId']);

            if (data['homePageReview'] !== null) {
                if (
                    // eslint-disable-next-line no-prototype-builtins
                    data['homePageReview'].hasOwnProperty('slug') &&
                    data['homePageReview'].slug !== null
                ) {
                    categoryStore.setHomePageReviewSlug(
                        data['homePageReview']['slug']
                    );
                }
            }

            if (Object.keys(this.sidebarRankingList).length === 0) {
                this.sidebarRankingList = this.categoryState.rankingList;
            }
        },
    },
};
